export const maxAllowedItemsValidation =
  <T>(maxItems: number, errorMessage: string) =>
  (items: T[] | null | undefined = []): boolean | string =>
    (items?.length ?? 0) <= maxItems || errorMessage;
